import { Star, StarHalf } from 'lucide-react';
import HeroTitle from './HeroTitle';
import Image from 'next/image';
import { Button } from '@/components';
import HeroMatrixTable from './HeroMatrixTable';

export default function Hero() {
  return (
    <section className="bg-white min-h-[75vh] lg:min-h-[80vh] px-4 sm:px-6 md:px-12 lg:px-0 xl:py-32 flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-8 lg:gap-5 container mx-auto">      {/* Content */}
     <div className="w-full lg:w-1/2 lg:flex-none flex flex-col justify-center order-2 lg:order-1 space-y-5">
        <HeroTitle
          badge="Performance Marketing Built for U.S. Growth Brands"
          title="Performance Marketing Agency for U.S. Brands Focused on Revenue Growth"
          description="Analyze user journeys, navigation patterns, content visibility, and conversion pathways to uncover usability issues and create experiences that drive engagement and growth."
          align="left"
          titleMaxWidth="3xl"
          descriptionMaxWidth='lg'
        />

        {/* Metrics */}
        <div className="flex flex-wrap items-center justify-center lg:justify-start  gap-4 ">
          {/* Google Reviews */}
          <div className="flex flex-col items-center gap-2 font-semibold text-sm ">
            <div className="flex items-center">
              {[...Array(4)].map((_, index) => (
                <Star
                  key={index}
                  className={`h-4 w-4 fill-yellow-400 text-yellow-400 ${index > 0 ? 'hidden lg:block' : ''
                    }`}
                />
              ))}

              <StarHalf className={`h-4 w-4  fill-yellow-400 text-yellow-400 
                    }`} />
            </div>
            <span>4.3 Google Reviews</span>
          </div>

          {/* ROAS */}
          <div className="flex flex-col items-center  font-semibold text-sm ">
            <Image
              src="/icons/specialpage/growth.png"
              alt="Growth"
              width={24}
              height={24}
              className="object-contain h-5 w-5 md:h-6 md:w-6"
            />
            <span>3.2x Average ROAS</span>
          </div>

          {/* Client Tenure */}
          <div className="flex flex-col items-center  font-semibold text-sm ">
            <Image
              src="/icons/specialpage/handsake.png"
              alt="Handshake"
              width={24}
              height={24}
              className="object-contain h-5 w-5 md:h-6 md:w-6"
            />
            <span>24 Months Avg Client Tenure</span>
          </div>
        </div>

        {/* CTA */}
        <div className="flex justify-center lg:justify-start">
          <Button variant="primary" href="/case-study" size="lg">
            View Case Studies
          </Button>
        </div>
      </div>

     
      <div className="w-full lg:w-1/2 lg:flex-none flex justify-center lg:justify-end order-1 lg:order-2">
  <HeroMatrixTable />
</div>
    </section>
  );
}